import { RESET_SCHEDULE } from './index'

export const requestResetSchedule = (payload) => ({
  type: RESET_SCHEDULE.REQUEST,
  payload,
})